module.exports = __webpack_public_path__ + "static/media/resource-document.6ae49cfe.svg";